import React from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";

class TablaActividades extends React.Component {
  state = {
    column: null,
    data: this.props.listaActividades,
    direction: null
  };

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({
      data: nextProps.listaActividades
    });
  }

  handleSort = clickedColumn => () => {
    const { column, data, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: _.sortBy(data, [clickedColumn]),
        direction: "ascending"
      });

      return;
    }

    this.setState({
      data: data.reverse(),
      direction: direction === "ascending" ? "descending" : "ascending"
    });
  };

  render() {
    const { column, data, direction } = this.state;

    return (
      <Table sortable celled fixed>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell
              sorted={column === "nombre" ? direction : null}
              onClick={this.handleSort("nombre")}
            >
              Nombre
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={column === "importe" ? direction : null}
              onClick={this.handleSort("importe")}
            >
              Importe
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={column === "descripcion" ? direction : null}
              onClick={this.handleSort("descripcion")}
            >
              Descripción
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {_.map(data, d => (
            <Table.Row
              key={d.id}
              onClick={() => this.props.handleRowClick(d.id)}
            >
              <Table.Cell>{d.nombre}</Table.Cell>
              <Table.Cell>{d.importe}</Table.Cell>
              <Table.Cell>{d.descripcion}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    );
  }
}

export default TablaActividades;



// WEBPACK FOOTER //
// ./src/pages/listados/listadoActividades/TablaActividades.jsx